import omit from 'lodash/omit';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { getProjectModelIdsForIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateProjectModelIds =
  (prevIri: string, newIri: string) => (model: Model) => {
    setDataProperty<ModelData>(model)(model.modelData, 'modelsByIri', {
      ...omit(model.modelData.modelsByIri, prevIri),
      [newIri]: getProjectModelIdsForIri(prevIri, model),
    });
  };
